import { useEffect, useState } from "react";
import { formatIST } from "@/lib/time";

export default function Watermark({ email, dark = false, contained = false }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);
  const stamp = `${email} • ${formatIST(now, "short")}`;
  const cells = Array.from({ length: 60 });
  return (
    <div className={`wm-layer ${dark ? "dark" : ""} ${contained ? "contained" : ""}`} aria-hidden="true" data-testid={contained ? "prep-watermark" : "watermark-layer"}>
      <div className={`wm-grid ${dark ? "dark" : ""}`}>
        {cells.map((_, i) => (
          <div key={i}>CONFIDENTIAL FRANCHISE DOCUMENT — {stamp}</div>
        ))}
      </div>
    </div>
  );
}
